import { LegalClientActivityEntity } from 'api/types/entity';
import { yesOrNot } from 'helpers';
import { TFunc } from 'libs/i18n';
import { Maybe } from 'types/maybe';

import { CompanyActivityFormType } from '../../forms/companyActivityForm';

export const getInitialData = (
  data: Maybe<LegalClientActivityEntity> | undefined,
  t: TFunc
): CompanyActivityFormType | undefined => {
  if (!data) {
    return undefined;
  }

  return {
    activity: {
      label: t(`onboarding.companyActivity.activity.types.${data.activity}`),
      value: data.activity,
    },
    isLargeEnterprise: yesOrNot(t, data.isLargeEnterprise)!,
    isNominalHolder: yesOrNot(t, data.isNominalHolder)!,
    requiresNominalHoldingSubaccount: yesOrNot(
      t,
      data.requiresNominalHoldingSubaccount
    ),
    otherActivity: data.otherActivity,
  };
};
